import { ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

export function ProtectedRoute({ 
  children, 
  redirectTo = '/' 
}: ProtectedRouteProps) {
  const { session } = useAuth();
  const location = useLocation();

  if (session.isLoading) {
    // You could render a loading spinner here
    return (
      <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-background">
        <div className="w-full max-w-md space-y-6 sm:space-y-8">
          <div className="text-center">
            <h1 className="heading-mobile">Loading...</h1>
            <p className="mt-2 text-gray-600">Please wait while we verify your session.</p>
          </div>
        </div>
      </div>
    );
  }

  if (!session.isAuthenticated) {
    // Redirect to login page but save the attempted URL
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
} 